import { QC_RULE_RID_SUMMARY_VALUES } from '../constants/qc-rule-vocabulary';

// The single value that names a respondent's ResponseID verdict, as the grid cell, the column
// filter, the rule builder and the export all show it. ResponseID's recommendation follows its
// rating - Low is always None and Medium always Review - so the rating alone names those two, and
// only High needs the recommendation to tell a plain High (review) from a hard stop (auto-QC).
//
// A High whose recommendation is missing or unrecognised falls back to the bare rating so the
// record still shows in the grid; no filter option or rule value names that fallback.

/** The verdict key: 'low' | 'medium' | 'high-review' | 'high-auto-qc' | 'high' (fallback) | null. */
export function ridSummaryValue(rating: string | null | undefined, action: string | null | undefined): string | null {
  const level = rating?.toLowerCase();
  if (level === 'low' || level === 'medium') return level;
  if (level !== 'high') return null;

  const recommendation = action?.toLowerCase();
  if (recommendation === 'auto-qc') return 'high-auto-qc';
  if (recommendation === 'review') return 'high-review';
  return 'high';
}

/** The verdict as the user reads it, or null where the key is not one this vocabulary knows. */
export function ridSummaryLabel(value: string | null | undefined): string | null {
  if (!value) return null;
  if (value === 'high') return 'High';
  return QC_RULE_RID_SUMMARY_VALUES[value] ?? null;
}
